import React from "react";
import Chart from "react-google-charts";
import './style.css'

export const options = {
  pieHole: 0.3,
  is3D: false,
  backgroundColor: 'transparent',
  legend: {
    position: "none", // Set the legend position to 'none' to remove the legend
  },
  colors: ["#d7e1f5", "#FE4E00", "#278B28"],
  chartArea: {
    left: 0,
    right: 0,
    top: 7,
    bottom: 7,
    width: '100%',
    height: '100%',
  },
  pieSliceTextStyle: {
    color: 'black', // Text color inside the pie slices
  },
  pieSliceBorderColor: 'transparent',
  sliceVisibilityThreshold: 0,
  shadow: 'none',
};

const PerformanceChart = ({data}) => {

  return (
    <Chart
      chartType="PieChart"
      width="12vw"
      height='12vw'
      data={data}
      options={options}
      className="donut-chart"
    />
  );
};

export default PerformanceChart;
